const Posts =()=>{
 return(
    <div>
        <h2>Posts</h2>
    </div>
 )
}
export default Posts;